import { ReactNode } from 'react';
import { Link } from 'react-router';

interface AuthCardProps {
  title: string;
  titleAccent?: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}

export const AuthCard = ({ title, titleAccent, subtitle, children, footer }: AuthCardProps) => {
  return (
    <div className="min-h-screen bg-brand-paper flex flex-col">
      <div className="flex flex-1 items-center justify-center px-4 py-10 sm:px-6 sm:py-16">
        <div className="w-full max-w-md">
          <Link
            to="/"
            aria-label="Forecast Engine — home"
            className="mb-8 flex justify-center"
          >
            <img src="/logo-header-light.svg" alt="Forecast Engine" className="h-14 w-auto" />
          </Link>

          <div className="rounded-2xl border border-brand-rule/15 bg-card px-6 py-8 sm:px-10 sm:py-10 shadow-[0_24px_60px_-32px_rgba(8,18,43,0.22)]">
            <div className="text-center">
              <h1 className="font-display text-[32px] sm:text-[34px] leading-[1.05] tracking-tight text-brand-ink">
                {title}
                {titleAccent && (
                  <>
                    {' '}
                    <span className="italic font-medium text-brand-teal">
                      {titleAccent}
                    </span>
                  </>
                )}
              </h1>
              {subtitle && (
                <p className="mt-3 text-sm sm:text-[15px] leading-relaxed text-brand-fog">
                  {subtitle}
                </p>
              )}
            </div>

            <div className="mt-7 sm:mt-8">{children}</div>
          </div>

          {footer && (
            <div className="mt-6 text-center text-sm text-brand-fog">
              {footer}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthCard;
